export default __webpack_public_path__ + "static/media/blue-felt.32d9400d.webp";